import { BasicTenant } from 'graphql/generated/graphqlTypes';

export function generateMockBasicTenant({
  additionalData = null,
  name = 'mockBasicTenantName',
  tenantId = 'mockBasicTenantTenantId',
  onboardingStep = 'TenantReadyEntra'
}: Partial<Omit<BasicTenant, '__typename'>>): BasicTenant {
  return {
    __typename: 'BasicTenant',
    additionalData,
    name,
    tenantId,
    onboardingStep
  };
}
